<template>
  <div class="block-legal">
    <div class="container">
      <button
        class="block-legal__btn"
        @click="expand"
      >
        Ознакомиться с условиями и предложениями
      </button>
      <transition name="slide">
        <div
          class="block-legal__text"
          v-if="expanded"
        >
          <div class="block-legal__item">
            <p class="block-legal__bottom">
              Реклама. ООО «{{ yur_name }}». Не оферта. Количество автомобилей
              ограничено. ООО «ДЖИЛИ-МОТОРС» вправе изменить сроки и условия
              Программы. Предложение действует с {{ firstDayDate }} г. по
              {{ lastDayDate }} г. Подробные условия и наличие автомобилей
              уточняйте у менеджеров ДЦ Geely {{ dealer_name }}.
              <a :href="'https://' + site">www.{{ site }}</a>
            </p>
            <br />

            *Обращаем Ваше внимание на то, что вся представленная на сайте
            информация, касающаяся комплектаций, технических характеристик,
            цветовых сочетаний, а также стоимости автомобилей и сервисного
            обслуживания носит информационный характер и ни при каких условиях
            не является публичной офертой, определяемой положениями Статьи 437
            (2) Гражданского кодекса Российской Федерации. Для получения
            подробной информации, пожалуйста, обращайтесь в наш салон. Сумма
            страховой премии, оплачиваемой страхователем при заключении договора
            страхования транспортного средства (КАСКО) в рамках программы дилера
            «КАСКО в подарок», компенсируется снижением дилером цены на
            автомобили Geely. Предложение не является офертой, действительно для
            физических лиц до {{ lastDayDate }} г. Подробности об автомобилях,
            участвующих в акции узнавайте в отделе продаж официального дилера
            Geely Автомир. Предложение ограничено. Любая информация,
            содержащаяся на настоящем сайте, носит исключительно справочный
            характер и ни при каких обстоятельствах не может быть расценена как
            предложение заключить договор (публичная оферта). Технические
            характеристики и оборудование автомобилей, условия приобретения
            автомобилей, цены, спецпредложения и комплектации автомобилей,
            указанные на сайте, приведены для примера и могут быть изменены в
            любое время без предварительного уведомления. Подробности об
            организаторе акции, правилах её проведения, количестве призов,
            сроках, месте и порядке их получения в официальных дилерских центрах
            Geely ГК Автомир по адресу: г. <b>Химки</b>, Ленинградское шоссе,
            вл.18. Предложение действует с {{ firstDayDate }} г. по
            {{ lastDayDate }} г. <br /><br /><br />

            <b>Рассрочка 0,01%</b> предложение распространяется на новые
            автомобили Geely.
            <br />
            <br />Процентная ставка варьируется от 0,010% до 27,746% годовых и
            зависит от кредитного предложения банков-партнеров, суммы
            первоначального взноса, оформления страхования, размера и срока
            автокредита. Минимальный пакет документов для оформления — паспорт
            гражданина РФ; <br />Указанная процентная ставка от 0,01 % в год
            достигается при следующих условиях кредитования: первоначальный
            взнос от 70% и более, сумма кредита от 300 000 руб. до 7 000 000
            руб., срок кредитования по программе и данной кредитной ставке до 36
            мес., КАСКО по весь период кредита. Обеспечение по кредиту — залог
            приобретенного автомобиля. <br />Программа действует с
            {{ firstDayDate }} г. по {{ lastDayDate }} г. Условия и тарифы могут
            быть изменены банком-партнером или импортёром (ООО «ДЖИЛИ-МОТОРС») в
            одностороннем порядке. Банк-партнер в праве отказать в выдаче
            автокредита. <br />Кредит предоставляется банками-партнерами: ООО
            «Драйв Клик Банк» ИНН 6452010742, ОГРН 1027739664260, место
            нахождения: 125124 г. Москва, ул. Правды, д. 26. Лицензия Банка
            России № 2168 от 09.12.2022., АО «ТБанк» ИНН 7710140679, ОГРН
            1027739642281, место нахождения: 127287, г. Москва, ул. Хуторская
            2-я, д. 38А, стр. 26, Лицензия Банка России № 2673 от 24.03.2015;
            ПАО «Совкомбанк» ИНН 4401116480, ОГРН 1144400000425, место
            нахождения: 156000, Костромская Область, г. Кострома, пр-кт
            Текстильщиков, д. 46. Лицензия Банка России № 963 от 05.12.2014; АО
            “АЛЬФА-БАНК” ИНН 7728168971, ОГРН 1027700067328, 107078, место
            нахождения: г. Москва, ул. Каланчевская, д. 27. Лицензия Банка России
            №1326 от 16.01.2015. <br />Подробные условия уточняйте у менеджеров
            кредитно-страхового отдела в официальном дилерском центре «Geely»
            {{ dealer_name }}, по адресу: {{ address }} ,
            <a
              target="_blank"
              rel="noopener"
              href="www.geely-avtomir.ru"
              >www.geely-avtomir.ru</a
            >, либо на сайте
            <a
              target="_blank"
              rel="noopener"
              href="https://credit-geely-cars.ru/"
              >https://credit-geely-cars.ru/</a
            >
            <br /><br />
            <b>Топ-2*</b><br />
            <b>Лучших дилеров по продажам в Центральном федеральном округе</b>
            <br /><b
              >*Дилер входит в Топ 2 Лучших дилеров в Центральном федеральном
              округе в рейтинге ООО «ДЖИЛИ-МОТОРС» по продажам и качеству
              обслуживания клиентов по итогам 4 квартала 2024 г.</b
            >
            <br />
            <b>
              <a
                target="_blank"
                rel="noopener"
                href="https://www.geely-motors.com/forbuyers/findadealer"
                >https://www.geely-motors.com/forbuyers/findadealer</a
              ></b
            >
          </div>
          <div
            v-for="(item, i) of Disclaimer"
            :key="i"
            class="block-legal__item"
          >
            <div
              class="block-legal__item-text"
              v-html="item"
            ></div>

            <p v-if="i > 0" class="block-legal__bottom">
              Реклама. ООО «{{ yur_name }}». Не оферта. Количество автомобилей
              ограничено. ООО «ДЖИЛИ-МОТОРС» вправе изменить сроки и условия
              Программы. Предложение действует с {{ firstDayDate }} г. по
              {{ lastDayDate }} г. Подробные условия и наличие автомобилей
              уточняйте у менеджеров ДЦ Geely {{ dealer_name }}.
              <a :href="'https://' + site">www.{{ site }}</a>
            </p>
          </div>
        </div>
      </transition>

      <div class="block-legal__polit">
        <a
          target="_blank"
          rel="noopener"
          href="https://avtomir.ru/disclaimer/politic/"
          class="block-legal__btn"
        >
          Политика Конфиденциальности
        </a>
      </div>

      <div class="block-legal__agreement">
        <a
          target="_blank"
          rel="noopener"
          href="https://avtomir.ru/disclaimer/politic/"
          class="block-legal__btn"
        >
          Согласие на обработку персональных данных
        </a>
      </div>

      <div id="bottom"></div>
    </div>
  </div>
</template>

<script>
import Mixin from "../common/mixin";
import Disclaimer from "../common/disclaimer";
import Contacts from "../common/constants.js";
import { getFirstDayDate, getLastDayDate } from "../common/date";
const { address, dealer_phone, salon_name, yur_name, dealer_name, site } =
  Contacts;

export default {
  name: "block-legal",
  mixins: [Mixin],
  data() {
    return {
      timer: null,
      expanded: false,
      Disclaimer,
      dealer_phone,
      address,
      salon_name,
      yur_name,
      dealer_name,
      site,
      firstDayDate: null,
      lastDayDate: null,
    };
  },
  mounted() {
    this.firstDayDate = getFirstDayDate();
    this.lastDayDate = getLastDayDate();
  },
  computed: {
    today() {
      return new Date();
    },
    current_year() {
      return this.today.getFullYear();
    },
    start_date() {
      return (
        "01" +
        "." +
        (+this.today.getMonth() + 1 < 10 ? "0" : "") +
        (this.today.getMonth() + 1) +
        "." +
        this.today.getFullYear()
      );
    },
    end_date() {
      return (
        this.getLastDayOfMonth(
          this.today.getFullYear(),
          this.today.getMonth()
        ) +
        "." +
        (+this.today.getMonth() + 1 < 10 ? "0" : "") +
        (this.today.getMonth() + 1) +
        "." +
        this.today.getFullYear()
      );
    },
  },
  methods: {
    getLastDayOfMonth(year, month) {
      let date = new Date(year, month + 1, 0);
      return date.getDate();
    },
    scrollTo(where) {
      this.$emit("scrollTo", where);
    },
    expand() {
      this.expanded = !this.expanded;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => this.scrollTo("bottom"), 100);
    },
    getAgreement() {
      this.$emit("getAgreement");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.block-legal {
  width: 100%;
  padding: 30px 0;
  font-size: 14px;
  font-weight: 400;
  color: $primary-text;
  text-align: center;
  background-color: #fff;

  &__btn {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: $red;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-decoration: underline;
  }

  &__text {
    text-align: start;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: justify;

    b {
      font-weight: bold;
    }
  }

  &__polit,
  &__agreement {
    margin-top: 15px;
  }

  &__item {
    margin-top: 1em;

    &-text {
      &::v-deep h3,
      &::v-deep h4 {
        color: $blue;
        font-weight: bold;
      }

      &::v-deep h3 {
        font-size: 1.3em;
        margin-bottom: 0.5em;
      }

      &::v-deep h4 {
        font-size: 1.2em;
        margin-bottom: 0.5em;
      }

      &::v-deep p {
        font-size: 1.1em;
        font-weight: bold;
        margin-bottom: 0.2em;
      }
    }
  }

  &__heading {
    font-size: 1.2em;
    font-weight: 700;
    margin-top: 1.7em;
    margin-bottom: 0.5em;
    line-height: 1.2;
  }

  &__bottom {
    font-style: italic;
    margin-top: 0.5em;
  }

  &__info {
    margin-top: 30px;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
  }
}

// Transition
.slide-enter-active {
  transition: all 0.3s ease;
}

.slide-leave-active {
  transition: all 0.3s;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

@media (max-width: 640px) {
  .block-legal {
    &__btn {
      font-size: 12px;
      line-height: 14px;
    }

    &__text {
      font-size: 10px;
      line-height: 12px;
    }

    &__polit,
    &__agreement {
      margin-top: 10px;
    }
  }
}
</style>
